export const CALL_FEATURES = [
    {display:'Callable', value:'holdCallableInd=Y'},
    {display:'Make Whole Call', value:'holdWholeCallInd=Y'},
    {display:'Non-Callable', value:'holdCallableInd=N'},
].map(a => {
    a.label = a.display
    return a
})


export const PUT_FEATURES = [
    {display:'Puttable', value:'holdPutableInd=Y'},
    {display:'Mandatory', value:'holdPutType=MAN', oneOf:'holdPutableInd=Y' },
    {display:'Conditional', value:'holdPutType=COND', oneOf:'holdPutableInd=Y' },
    {display:'Survivor', value:'holdPutType=SUR', oneOf:'holdPutableInd=Y' },
    {display:'Non-Puttable', value:'holdPutableInd=N'}
].map(a => {
    a.label = a.display
    return a
})


export const OTHER_FEATURES = [
    {display:'Sinking Fund', value:'holdNextSink=Y'},
    {display:'No Sinking Fund', value:'holdNextSink=N'},
    {display:'Extraordinary Redemption Provision', value:'holdErpInd=Y'},
    {display:'Non-Extraordinary Redemption Provision', value:'holdErpInd=N'}
].map(a => {
    a.label = a.display
    return a
})

